import { Component} from '@angular/core';

@Component({
    selector: 'via-results-page',
    templateUrl: './results-page.component.html',
    styleUrls: ['./results-page.component.scss'],
})
export class ResultsPageComponent {
}
